var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareScreenOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 2,
    height: 6,
    rx: 1,
    strokeWidth: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 16,
    height: 2,
    rx: 1,
    strokeWidth: 1,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 5.79086 2.79086 4 5 4H27C29.2091 4 31 5.79086 31 8V22C31 24.2091 29.2091 26 27 26H5C2.79086 26 1 24.2091 1 22V8Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5199 8.20307C15.785 7.93231 16.215 7.93231 16.4801 8.20307L20.8011 12.6154C21.0663 12.8862 21.0663 13.3252 20.8011 13.5959C20.536 13.8667 20.1061 13.8667 19.8409 13.5959L16.679 10.3672V20.3067C16.679 20.6896 16.375 21 16 21C15.625 21 15.321 20.6896 15.321 20.3067V10.3672L12.1591 13.5959C11.8939 13.8667 11.464 13.8667 11.1989 13.5959C10.9337 13.3252 10.9337 12.8862 11.1989 12.6154L15.5199 8.20307Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenOut);
export default __webpack_public_path__ + "static/media/share-screen-out.f16108832d99bf0742b4e97c63761057.svg";
export { ForwardRef as ReactComponent };